// Stable API values and readable labels for support triage.
export const SUPPORT_CATEGORIES = Object.freeze({
  account: 'Account help',
  reportMember: 'Report a member',
  reportBug: 'Report a bug',
  volunteering: 'Volunteering',
  other: 'Other',
});

const categories = { SUPPORT_CATEGORIES };

export default categories;
